import React from "react";
import { Text } from "react-native";

const CustomText = ({ style = {}, children }) => (
  <Text
    style={[
      {
        fontSize: 20,
        lineHeight: 28,
        fontFamily: "NotoSansDevanagari-Regular",
        color: "rgba(0,0,0,0.8)",
      },
      style,
    ]}
  >
    {children}
  </Text>
);

export default CustomText;
